module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3GRIL"))).then(() => parcelRequire('hEqeo'));